<template>
  <div>
    <alert
      v-if="exibeErro"
      type="danger"
      title="Atenção!!"
      active="true"
      class="my-3"
      style="height:auto !important"
    >
      <h5>Atenção!</h5>
      <p v-html="msgErro"></p>
    </alert>
    <alert
      v-if="exibeErro==false && listaErro.length >0"
      type="danger"
      title="Atenção!!"
      active="true"
      class="my-3"
      style="height:auto !important"
    >
      <h5>Atenção!</h5>
      <ul class="unstyle">
        <li class="mb-2" v-for="error in listaErro" :key="error.id">{{ error }}</li>
      </ul>
    </alert>
  </div>
</template>
<script>
import { Alert } from "@/components";

export default {
  props: ["exibeErro", "msgErro", "listaErro"],
  components: {
    Alert
  }
};
</script>
<style>
.tab-content.tab-content-padding {
  padding: 20px;
}
.unstyle {
  list-style: none;
  font-size: 12px;
  padding: 0px;
}
</style>
